import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";
import Modal from "react-modal";
import {
  fieldsInitial,
  farmerTypeOptions,
  switchEmpFar,
  switchType,
  switchEmplabelFar,
} from "./../model-gatepass";

const GatePassInForm = (props) => {
  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const frmRef = useRef({});

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);

  const [fields, setFields] = useState(fieldsInitial);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const [selectedType, setSelectedType] = useState(null);
  const [selectionType, setSelectionType] = useState(null);

  const [assignEmployeeId, setAssignEmployeeId] = useState(null);

  const [employeeId, setEmployeeId] = useState(null);
  const [employeelist, setEmployeelist] = useState(null);

  const [vehiclelist, setVehiclelist] = useState(null);
  const [vmerId, setvmerId] = useState();
  const [vehiclenumber, setVehiclenumber] = useState();

  const [weightUnitId, setweightUnitId] = useState([]);
  const [weightunitList, setweightUnitList] = useState([]);
  const [unitList, setUnitList] = useState();
  const [farmerId, setFarmerId] = useState(null);
  const [farmerlist, setFarmerlist] = useState(null);
  const [harvestDate, setHarvestDate] = useState("");
  const [mrlStatus, setMRLStatus] = useState(null);
  const [cropPlotId, setcropPlotId] = useState(null);
  const [cropPlotList, setcropPlotList] = useState(null);
  const [curingDetail, setCuringDetailList] = useState(null);

  const [cropList, setCropList] = useState([]);
  const [cropId, setcropId] = useState(null);
  const [procurementVehiclesDetailId, setProcurementVehiclesDetailId] =
    useState(null);

  const [cropVarietyList, setcropVarietyList] = useState([]);
  const [varietyId, setvarietyId] = useState(null);
  const [cropVarietyFliterList, setcropVarietyFliterList] = useState([]);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [cropClose, setCropClose] = useState(false);
  const [procurmentClose, setprocurmentClose] = useState(false);

  const [procIds, setProcIds] = useState();

  const [docNoFor, setdocNoFor] = useState();

  const [docList, setDocList] = useState([]);
  const [docId, setDocId] = useState(0);

  const [loadQuantityunitId, setLoadQuantityunitId] = useState();

  const [loading, setLoading] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const { sendRequest: postGatePass } = useHttp();

  const { sendRequest: getFarmerProc } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    frmRef.current.inTime.value =
      (d.getHours() < 10 ? "0" : "") +
      d.getHours().toString() +
      ":" +
      (d.getMinutes() < 10 ? "0" : "") +
      d.getMinutes().toString();
    //console.log("time_stamp1", frmRef.current.inTime.value);
  }, [selectedDate]);

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getVehicle } = useHttp();
  useEffect(() => {
    getVehicle(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
      },
      (res) => {
        if (res) {
          var vehicle = res.filter((x) => x.vmeClassific == "Vehicle");
          //console.log(vehicle);
          setVehiclelist(vehicle);
        }
      }
    );
  }, [getVehicle]);

  const { sendRequest: getFarmer } = useHttp();

  useEffect(() => {
    getFarmer(
      {
        url: "/api/getAllFarmersWeb/",
        method: "GET",
      },
      (data) => {
        //console.log("setFarmerlist", data);

        data = data.sort((a, b) => (a.farmerName > b.farmerName ? 1 : -1));
        //console.log("setFarmerlist sort", data);
        setFarmerlist(data);
      }
    );
  }, [getFarmer]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          console.log("units", res);

          var unitFilter = res.filter((item) => item.unitTypeId == 2);

          //console.log("unitFilter", unitFilter);

          setUnitList(unitFilter);
          setweightUnitList(unitFilter);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const { sendRequest: getcrop } = useHttp();
  useEffect(() => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropList(res);
        }
      }
    );
  }, [getcrop]);

  const cropOnchangedHandler = (event) => {
    //console.log(event.target.value);

    var tempCropId = event.target.value;
    setcropId(event.target.value);
    setcropVarietyFliterList([]);

    const FilterList = cropVarietyList.filter(
      (item) => parseInt(item.cropId) === parseInt(tempCropId)
    );

    setcropVarietyFliterList(FilterList);
  };

  const { sendRequest: getcropVariety } = useHttp();

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: "/api/varieties/",
      },
      (res) => {
        if (res) {
          //console.log("setcropVarietyList", res);
          setcropVarietyList(res);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail();
  }, [getcropVariety]);

  const { sendRequest: getprocurement } = useHttp();

  const getprocurementData = (id) => {
    const pdata = { createdBy: "2" };

    setcropPlotId(null);
    setProductDetails([]);
    getprocurement(
      {
        url: `/api/getAllProcurementForGatepass/?farmerId=${id}`,
        method: "GET",
      },
      (data) => {
        setcropPlotList(data.procurementDetails);

        var farmerdata = farmerlist.filter((item) => item.farmerId == id);
        if (farmerdata.length > 0) {
          frmRef.current.personName.value = farmerdata[0].farmerName;
          frmRef.current.email.value = farmerdata[0].email;
          frmRef.current.contactnumber.value = farmerdata[0].mobile;
          frmRef.current.whatAppContactNumber.value = farmerdata[0].mobile;
        }
      }
    );
  };

  useEffect(() => {
    getprocurementData();
  }, [getprocurement]);

  const { sendRequest: getTobaccoprocurement } = useHttp();

  const getTobaccoprocurementData = (id) => {
    const pdata = { createdBy: "2" };

    setcropPlotId(null);
    setProductDetails([]);
    getprocurement(
      {
        url: `/api/curingDetailForGetpass?farmerId=${id}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        method: "GET",
      },
      (data) => {
        setCuringDetailList(data.curingDetails);

        var farmerdata = farmerlist.filter((item) => item.farmerId == id);
        if (farmerdata.length > 0) {
          frmRef.current.personName.value = farmerdata[0].farmerName;
          frmRef.current.email.value = farmerdata[0].email;
          frmRef.current.contactnumber.value = farmerdata[0].mobile;
          frmRef.current.whatAppContactNumber.value = farmerdata[0].mobile;
        }
      }
    );
  };

  useEffect(() => {
    getTobaccoprocurementData();
  }, [getTobaccoprocurement]);

  const { sendRequest: getemployeeDataload } = useHttp();

  const getemployeeloaddetail = (id) => {
    console.log(id);

    var procItem =
      cropPlotList && cropPlotList.filter((item) => item.cropId == id);

    var url = ``;

    var urlfilter = "";

    var empData = employeelist.filter((item) => item.empId == id);
    if (empData && empData.length > 0) {
      var empp = empData[0];
      frmRef.current.personName.value = empp.employeeName;
      frmRef.current.email.value = empp.emailId;
      frmRef.current.contactnumber.value = empp.contactNo;
      frmRef.current.whatAppContactNumber.value = empp.whatsappNo;
    }

    if (switchEmplabelFar(selectedType) == "Purchase Order No :") {
      url = `/api/getpurchaseOrderForGRN/?orgId=${localStorage.getItem(
        "orgId"
      )}${urlfilter} `;
    }

    if (switchEmplabelFar(selectedType) == "Harvest No :") {
      url = `/api/harvestVehicleDetailForGetPass/?orgId=${localStorage.getItem(
        "orgId"
      )}${urlfilter} `;
    }

    getemployeeDataload(
      {
        url: url,
      },
      (res) => {
        var newDocList = [];
        //console.log("getpurchaseOrderForGRN", res);
        if (switchEmplabelFar(selectedType) == "Purchase Order No :") {
          if (res.output.length > 0) {
            res.output.forEach((item) => {
              newDocList = newDocList.concat({
                docNo: item.docNo,
                docId: item.purchaseOrderId,
              });
            });
          }
        }

        if (switchEmplabelFar(selectedType) == "Harvest No :") {
          if (res.HarvestBatchTransitlist.length > 0) {
            res.HarvestBatchTransitlist.forEach((item) => {
              newDocList = newDocList.concat({
                docNo: item.harvestNo + "(" + item.vmeNo + ")",
                docId: item.harvestBatchTransitId,
                loadQuantity: item.loadQuantity,
                loadQuantityUnitId: item.loadQuantityUnitId,
                cropName: item.cropName,
                varietyName: item.varietyName,
                unitAbbreviation: item.unitAbbreviation,
                driverName: item.driverName,
                driverMobileNumber: item.driverMobileNumber,
                vehicleNumber: item.vmeNo,
                harvestDate: item.harvestDate,
                cropId: item.cropId,
                varietyId: item.varietyId,
              });
            });
          }
        }

        setDocList(newDocList);
      }
    );
  };

  const { sendRequest: getemployeeDocproductDetail } = useHttp();

  const getemployeeDocDetail = (id) => {
    var procItem =
      cropPlotList && cropPlotList.filter((item) => item.cropId == id);

    var url = ``;

    var urlfilter = "";

    if (switchEmplabelFar(selectedType) == "Purchase Order No :") {
      url = `/api/purchaseOrderDetail/?orgId=${localStorage.getItem(
        "orgId"
      )}&purchaseOrderId=${id}`;
    }

    getemployeeDocproductDetail(
      {
        url: url,
      },
      (res) => {
      

        if (res.length > 0) {
          res.map((x) => (x["isSave"] = true));
          res.map((x) => (x["itemQuantity"] = x.orderQuantity));

          setProductDetails(res);
        } else {
          setProductDetails([]);
        }
      }
    );
  };

  const { sendRequest: getproductgradedetail } = useHttp();

  const loadProcurmentDetail = (id) => {
    var procItem =
      cropPlotList &&
      cropPlotList.filter((item) => item.procurementVehiclesDetailId == id);

    var productDetailsdata = [];
    setProductDetails([]);
    var varietyId = 0;
    if (procItem && procItem.length > 0) {
      varietyId = procItem[0].cropVarietyId;
    }
    getproductgradedetail(
      {
        url: `/api/productData/?cropData=crop&&varietyId=${varietyId}`,
      },
      (res) => {
        console.log("getproductgradedetail", res);

        if (procItem.length > 0) {
          var procItem1 = procItem[0];

          setcropPlotId(procItem1.cropId);

          setdocNoFor(procItem1.procurementNo);

          console.log("if");
          console.log("procItem1", procItem1);
          console.log(
            "procItem1.procurementVehiclesDetailId",
            procItem1.procurementVehiclesDetailId
          );
          setProcurementVehiclesDetailId(procItem1.procurementVehiclesDetailId);

          if (
            procItem1.gradeOneQty > 0 ||
            procItem1.gradeTwoQty > 0 ||
            procItem1.gradeThreeQty > 0
          ) {
            //console.log("Classwise");
            var k = 1;
            if ((procItem1.gradeOneQty || 0) > 0) {
              console.log("Classwise 1");
              console.log("Classwise getproductgradedetail", res);
              var itemlistclass1 = res.filter(
                (item) =>
                  parseInt(item.varietyId) ==
                    parseInt(procItem1.cropVarietyId) &&
                  parseInt(item.gradeId) > 0 &&
                  item.gradeName.toLowerCase() == "grade 1" &&
                  parseInt(item.inputproductId || "0") == 0
              );
              console.log(itemlistclass1);
              productDetailsdata = productDetailsdata.concat({
                srno: k,
                cropId: procItem1.cropMasterId,
                cropName: procItem1.cropName,
                grade: "Grade 1",
                varietyId: procItem1.cropVarietyId,
                varietyName: procItem1.cropVariety,
                itemQuantity: procItem1.gradeOneQty,
                unit: procItem1.unitAbbreviation,
                unitId: procItem1.unitId,
                rate: procItem1.classOneRate || 0,
                amount:
                  parseFloat(procItem1.classOneRate || 0) *
                  parseFloat(procItem1.gradeOneQty || 0),
                productId: itemlistclass1[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                gradeId: itemlistclass1[0].gradeId,
                createdBy: parseInt(localStorage.getItem("id")),
                orgId: localStorage.getItem("orgId"),
                status: 1,
                isSave: true,
              });

              k++;
            }
            console.log("productDetailsdata", productDetailsdata);
            if ((procItem1.gradeTwoQty || 0) > 0) {
              console.log("Classwise 2");
              var itemlistclass2 = res.filter(
                (item) =>
                  parseInt(item.varietyId) ==
                    parseInt(procItem1.cropVarietyId) &&
                  parseInt(item.gradeId) > 0 &&
                  item.gradeName.toLowerCase() == "grade 2" &&
                  parseInt(item.inputproductId || "0") == 0
              );

              productDetailsdata = productDetailsdata.concat({
                srno: k,
                cropId: procItem1.cropMasterId,
                cropName: procItem1.cropName,
                grade: "Grade 2",
                varietyId: procItem1.cropVarietyId,
                varietyName: procItem1.cropVariety,
                itemQuantity: procItem1.gradeTwoQty,
                unit: procItem1.unitAbbreviation,
                unitId: procItem1.unitId,
                rate: procItem1.classTwoRate || 0,
                amount:
                  parseFloat(procItem1.classTwoRate || 0) *
                  parseFloat(procItem1.gradeTwoQty || 0),

                productId: itemlistclass2[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                gradeId: itemlistclass2[0].gradeId,
                createdBy: parseInt(localStorage.getItem("id")),
                orgId: localStorage.getItem("orgId"),
                status: 1,
                isSave: true,
              });

              k++;
            }

            if ((procItem1.gradeThreeQty || 0) > 0) {
              console.log("Classwise 3");
              var itemlistclass3 = res.filter(
                (item) =>
                  parseInt(item.varietyId) ==
                    parseInt(procItem1.cropVarietyId) &&
                  parseInt(item.gradeId) > 0 &&
                  item.gradeName.toLowerCase() == "grade 3" &&
                  parseInt(item.inputproductId || "0") == 0
              );

              productDetailsdata = productDetailsdata.concat({
                srno: k,
                cropId: procItem1.cropMasterId,
                cropName: procItem1.cropName,
                grade: "Grade 3",
                varietyId: procItem1.cropVarietyId,
                varietyName: procItem1.cropVariety,
                itemQuantity: procItem1.gradeThreeQty,
                unit: procItem1.unitAbbreviation,
                unitId: procItem1.unitId,
                rate: procItem1.classThreeRate || 0,
                amount:
                  parseFloat(procItem1.classThreeRate || 0) *
                  parseFloat(procItem1.gradeThreeQty || 0),
                productId: itemlistclass3[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                gradeId: itemlistclass3[0].gradeId,
                createdBy: parseInt(localStorage.getItem("id")),
                orgId: localStorage.getItem("orgId"),
                status: 1,
                isSave: true,
              });
              k++;
            }

            if ((procItem1.gradeFourQty || 0) > 0) {
              console.log("Classwise 4");

              var itemlistclass4 = res.filter(
                (item) =>
                  parseInt(item.varietyId) ==
                    parseInt(procItem1.cropVarietyId) &&
                  parseInt(item.gradeId) > 0 &&
                  item.gradeName.toLowerCase() == "grade 4" &&
                  parseInt(item.inputproductId || "0") == 0
              );
              console.log(itemlistclass4);
              productDetailsdata = productDetailsdata.concat({
                srno: k,
                cropId: procItem1.cropMasterId,
                cropName: procItem1.cropName,
                grade: "Grade 4",
                varietyId: procItem1.cropVarietyId,
                varietyName: procItem1.cropVariety,
                itemQuantity: procItem1.gradeFourQty,
                unit: procItem1.unitAbbreviation,
                unitId: procItem1.unitId,
                rate: procItem1.classFourRate || 0,
                amount:
                  parseFloat(procItem1.classFourRate || 0) *
                  parseFloat(procItem1.gradeFourQty || 0),
                productId: itemlistclass4[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                gradeId: itemlistclass4[0].gradeId,
                createdBy: parseInt(localStorage.getItem("id")),
                orgId: localStorage.getItem("orgId"),
                status: 1,
                isSave: true,
              });

              k++;
            }
            console.log("productDetailsdata", productDetailsdata);
          } else {
            console.log("cropVarietyId", procItem1.cropVarietyId);
             
            var itemlistclass = res.filter(
              (item) =>
                parseInt(item.varietyId) == parseInt(procItem1.cropVarietyId) &&
                parseInt(item.gradeId ?? 0) == 0 &&
                item.productTypeNo == "RP" &&
                parseInt(item.inputproductId || "0") == 0
            );
            console.log("itemlistclass", itemlistclass);
            productDetailsdata = productDetailsdata.concat({
              srno: 1,
              cropId: procItem1.cropMasterId,
              cropName: procItem1.cropName,
              grade: "",
              varietyId: procItem1.cropVarietyId,
              varietyName: procItem1.cropVariety,
              itemQuantity: procItem1.loadQty,
              unit: procItem1.unitAbbreviation,
              unitId: procItem1.unitId,
              rate: procItem1.classTwoRate || 0,
              amount:
                parseFloat(procItem1.classTwoRate || 1) *
                parseFloat(procItem1.loadQty || 0),
              productId: itemlistclass[0].productId, //getpassproductdata && getpassproductdata[i].productId,

              createdBy: parseInt(localStorage.getItem("id")),
              orgId: localStorage.getItem("orgId"),
              status: 1,
              isSave: true,
            });
          }

          setProductDetails(productDetailsdata);

          frmRef.current.loadQuantity.value = procItem1.loadQty;
          setLoadQuantityunitId(procItem1.unitId);

          frmRef.current.vehicledrivername.value = procItem1.driverName;
          frmRef.current.drivercontactnumber.value = procItem1.driverNumber;
          frmRef.current.vehiclenumber.value = procItem1.vehicleNumber;
        }
      }
    );
  };

  const loadTobaccoProcurmentDetail = (id) => {
    var procItem =
      cropPlotList &&
      cropPlotList.filter((item) => item.procurementVehiclesDetailId == id);

    var productDetailsdata = [];
    setProductDetails([]);
    var curingDetailList = curingDetail.filter((item) => item.curingId == id);
    var productDetailsdata = [];

    {
      console.log("curingDetailList", curingDetailList);
      var itemTempObj = curingDetailList[0];
      if (curingDetailList && curingDetailList.length > 0)
        getproductgradedetail(
          {
            url: `/api/productData/?cropData=crop&varietyId=${itemTempObj.varietyId}`,
          },
          (res) => {
            console.log("res", res);

            var curingBalesDetails = itemTempObj.curingBalesDetails;

            for (var i = 0; i < curingBalesDetails.length; i++) {
              var itemObj = curingBalesDetails[i];
              console.log("itemObj", itemObj.gradeId);
              var itemlistclass = res.filter(
                (item) =>
                  parseInt(item.varietyId) == parseInt(itemTempObj.varietyId) &&
                  parseInt(item.gradeId ?? 0) == itemObj.gradeId &&
                  item.productTypeNo == "RP" &&
                  parseInt(item.inputproductId || "0") == 0
              );

              try {
                console.log("itemlistclass", itemlistclass);
                productDetailsdata = productDetailsdata.concat({
                  srno: 1,
                  cropId: itemlistclass[0].cropId,
                  cropName: itemlistclass[0].cropName,
                  varietyName: itemlistclass[0].varietyName,
                  grade: itemlistclass[0].gradeName,
                  varietyId: itemObj.cropVarietyId,
                  itemQuantity: itemObj.weightPerBales * itemObj.noOfBales,
                  weightPerBales: itemObj.weightPerBales,
                  noOfBales: itemObj.noOfBales,
                  unit: itemObj.unitAbbreviation,
                  unitId: itemObj.unitId,
                  rate: 0,
                  amount: 0,
                  productId: itemlistclass[0].productId, //getpassproductdata && getpassproductdata[i].productId,

                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                  status: 1,
                  isSave: true,
                });
              } catch {
                console.log("Hdaia");
              }
            }

            console.log("productDetailsdata 1", productDetailsdata);
            setProductDetails(productDetailsdata);
          }
        );
    }
  };

  const { sendRequest: getNameById } = useHttp();

  const handleId = (e) => {
    let nurl = `/api/getNamesById/?orgId=${localStorage.getItem("orgId")}`;
    if (selectedEntry && selectedEntry.value === 2) {
      nurl = `${nurl}&existingFarmer=${e.target.value}`;
    } else if (selectedEntry && selectedEntry.value === 3) {
      nurl = `${nurl}&existingEmployee=${e.target.value}`;
    } else {
      nurl = null;
    }
    if (nurl) {
      getNameById(
        {
          url: nurl,
        },
        (res) => {
          if (res) {
            if (selectedEntry && selectedEntry.value === 2) {
              const temp = {
                personName: res.farmerName || "",
                email: res.email || "",
                contactnumber: res.mobile || "",
                contactnumberwork: res.mobile || "",
              };
              setFields({ ...fields, ...temp });
            }
          }
        }
      );
    }
  };

  const { sendRequest: postgatePass } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);


    var getPassForName = "";

    if (selectedEntry == "New Farmer") {
      getPassForName = frmRef.current.personName.value;
    } else if (selectedEntry == "Existing Farmer") {
      getPassForName = frmRef.current.personName.value;
    } else {
      getPassForName = frmRef.current.personName.value;
    }

    var _vehiclenumber = "";
    if (selectionType.value == "Direct Harvest") {
      _vehiclenumber = vehiclenumber;
    } else {
      _vehiclenumber = frmRef.current.vehiclenumber.value;
    }


    const data = {
      getpassDate: moment(frmRef.current.getpassDate.value).format(
        "DD/MM/YYYY"
      ),
      inTime: frmRef.current.inTime.value,
      farmerId: farmerId,
      FarmerEmployeeId: employeeId,
      cropPlotId: cropPlotId,
      getpassType: selectedEntry.label,
      getpassFor: selectedType.label,
      getpassForId: docId,
      getPassForName: getPassForName,
      gatepassType: "In",
      docNoFor: docNoFor,
      procurementVehiclesDetailId: procurementVehiclesDetailId,
      mrlStatus: mrlStatus,
      personName: frmRef.current.personName.value,
      supervisorEmployeeId: assignEmployeeId,
      email: frmRef.current.email.value,
      contactnumber: frmRef.current.contactnumber.value,
      whatAppContactNumber: frmRef.current.whatAppContactNumber.value,
      vehicledrivername: frmRef.current.vehicledrivername.value,
      drivercontactnumber: frmRef.current.drivercontactnumber.value,
      loadQuantity: frmRef.current.loadQuantity.value,
      unitId: loadQuantityunitId,
      remarkNote: frmRef.current.remarkNote.value,
      vehiclenumber: _vehiclenumber,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      createdDate: dateString,
      productDetails: productDetails,
      serviceId: props.sId,
    };
    //console.log("data", data);
    if (harvestDate && harvestDate != "") {
      data["harvestDate"] = harvestDate && harvestDate;
    }

    if (props.update) {
      data["gatepassId"] = props.update.gatepassId;
    }
    //console.log(data);
    postgatePass(
      {
        url: "/api/gatePass/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Getpass Order ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
        setLoading(false)
      },(error) => {
       
        console.error("Error", error);
       
        
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (selectedEntry && selectedEntry.value === 1) {
      setFields({ ...fields, farmer_id: parseInt(Date.now() * Math.random()) });
    } else {
      setFields({ ...fields, farmer_id: "" });
    }
    const temp = {
      personName: "",
      email: "",
      contactnumber: "",
      contactnumberwork: "",
    };
    setFields({ ...fields, ...temp });
    setSelectionType(switchType(selectedEntry));
  }, [selectedEntry]);

  //product details modal

  const submitCrop = (e) => {
    e.preventDefault();
    var selectvarietylist = cropVarietyFliterList.filter(
      (item) => item.varietyId == varietyId
    );
    var variety = selectvarietylist && selectvarietylist[0];
    var selectUnitlist = weightunitList.filter(
      (item) => parseInt(item.unitId) == parseInt(weightUnitId)
    );
    var unitData = selectUnitlist && selectUnitlist[0];
    var itemQuantity = productRef.current.cropQuantity.value;

    var cropName = variety && variety.cropName;
    var varietyName = variety && variety.varietyName;
    var itemQuantity = productRef.current.cropQuantity.value;
    var unit = unitData && unitData.unitAbbreviation;

    if (!cropName || !varietyName || !itemQuantity || !unit) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      const count = productDetails.filter(
        (product) => product.varietyId == variety.varietyId
      ).length;

      if (count > 0) {
        toast.alert("Variety already exists!");
        return;
      } else {
        setProductDetails((x) => [
          ...x,
          {
            srno:
              productDetails.length > 0
                ? productDetails[productDetails.length - 1].srno + 1
                : 1,
            cropId: cropId,
            cropName: cropName,

            varietyId: varietyId,
            varietyName: varietyName,
            itemQuantity: itemQuantity,
            unit: unit,
            unitId: weightUnitId,
            createdBy: parseInt(localStorage.getItem("id")),
            orgId: localStorage.getItem("orgId"),
            status: 1,
          },
        ]);

        setcropId(0);
        setvarietyId(0);
        setweightUnitId(0);
        productRef.current.cropQuantity.value = "0";
        //console.log(productDetails);
      }
    }
  };
  const handlecropDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        itemId:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        status: 1,
      },
    ]);

    //console.log(productDetails);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const getProcData = () => {
    let nurl = `/api/getNamesById/?orgId=${localStorage.getItem("orgId")}`;
    nurl = `${nurl}&existingFarmer=${
      frmRef.current.farmer_id.value
    }&procurement=${true}`;
    getFarmerProc(
      {
        url: nurl,
      },
      (res) => {
        if (res) {
          setProcIds(res);
        }
      }
    );
  };

  const LoadVehicleData = (id) => {
    frmRef.current.vehicledrivername.value = "";
    frmRef.current.drivercontactnumber.value = "";

    var itemlist = vehiclelist.filter((item) => item.vmerId == id);
    var selectedItem = itemlist[0];

    setVehiclenumber(itemlist[0].vehicleNumber);
    frmRef.current.vehicledrivername.value =
      itemlist[0].assignedPersonDriverName;
    frmRef.current.drivercontactnumber.value =
      itemlist[0].assignedPersonContactNo;
  };

  return (
    <>
      {procurmentClose && (
        <Modal isOpen={procurmentClose} style={customModalStyles}>
          <div>
            <div className="">
              <h3 className="card-title">Product Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setprocurmentClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div></div>
            <div className="row mb-2">
              <table className="table table-bordered">
                <thead>
                  <tr className="">
                    <th>Sr. No</th>
                    <th>Crop </th>
                    <th>Variety</th>
                    <th>Grade</th>
                    <th>Item Quantity</th>
                    <th>Unit</th>
                    <th>Rate</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails &&
                    productDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{itm.srno}</td>
                          <td>{itm.cropName}</td>
                          <td>{itm.varietyName}</td>
                          <td>{itm.grade}</td>

                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unit}</td>
                          <td>{itm.rate}</td>
                          <td>{itm.amount}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      )}

      {cropClose && (
        <Modal isOpen={cropClose} style={customModalStyles}>
          <div>
            <div className="">
              <h3 className="card-title">Crop Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setCropClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                <label htmlFor={"cropName"}> Crop Name</label>
                <select
                  id="cropNameId"
                  className="form-control"
                  ref={(el) => (productRef.current["cropId"] = el)}
                  value={cropId}
                  onChange={cropOnchangedHandler}
                >
                  <option>--Select Crop--</option>
                  {cropList &&
                    cropList.map((x) => (
                      <option
                        key={x.cropId}
                        crop-id={x.cropId}
                        value={x.cropId}
                      >
                        {x.cropName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <label htmlFor={"VarietyName"}> Variety Name</label>

                <select
                  id="cropNameId"
                  className="form-control"
                  ref={(el) => (productRef.current["varietyId"] = el)}
                  value={varietyId}
                  onChange={(e) => {
                    setvarietyId(e.target.value);
                  }}
                >
                  <option>--Select Variety--</option>
                  {cropVarietyFliterList &&
                    cropVarietyFliterList.map((x) => (
                      <option
                        key={x.varietyId}
                        variety-id={x.varietyId}
                        value={x.varietyId}
                      >
                        {x.varietyName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"itemQuantity"}> Item Quantity</label>
                <input
                  type={"number"}
                  id={"cropQuantity"}
                  required
                  ref={(el) => (productRef.current["cropQuantity"] = el)}
                  className="form-control"
                />{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"unit"}> Unit</label>{" "}
                <select
                  id="unitId"
                  className="form-control"
                  ref={(el) => (frmRef.current["weightUnitId"] = el)}
                  value={weightUnitId}
                  onChange={(e) => {
                    setweightUnitId(e.target.value);
                  }}
                >
                  <option>--Select Unit--</option>
                  {weightunitList &&
                    weightunitList.map((x) => (
                      <option
                        key={x.unitId}
                        unit-id={x.unitId}
                        value={x.unitId}
                      >
                        {x.unitAbbreviation}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-4"> </div>
              <div className="col-md-1"> </div>
              <div className="col-md-1">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={submitCrop}
                >
                  +
                </button>{" "}
              </div>
              <div className="col-md-2"> </div>
              <div className="col-md-4"> </div>
            </div>
            <hr />

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Crop Name </th>
                  <th>Variety Name</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.cropName}</td>
                        <td>{itm.varietyName}</td>

                        <td>{itm.itemQuantity}</td>
                        <td>{itm.unit}</td>
                        {
                          <td>
                            <button
                              className="btn"
                              onClick={(e) => handleDelete(i, e)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        }
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <hr />

            <div className="row mb-2">
              <div className="col-md-4"> </div>
              <div className="col-md-1"> </div>
              <div className="col-md-1">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    productDetails.map((x) => (x["isSave"] = true));
                    setCropClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-2"> </div>
              <div className="col-md-4"> </div>
            </div>
          </div>
        </Modal>
      )}

      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div className="">
              <h3 className="card-title">Crop Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div className="row mb-2">
              {switchEmpFar(selectedType) == "Harvest" ? (
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Crop Name </th>
                      <th>Variety Name</th>
                      <th>Item Quantity</th>
                      <th>Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productDetails &&
                      productDetails.map((itm, i) => {
                        return (
                          <tr key={i}>
                            <td>{itm.srno}</td>
                            <td>{itm.cropName}</td>
                            <td>{itm.varietyName}</td>

                            <td>{itm.itemQuantity}</td>
                            <td>{itm.unit}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              ) : (
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Product Id</th>
                      <th>Product Name</th>
                      <th>Product Type</th>
                      <th>Product Subtype</th>
                      <th>Product Quantity</th>
                      <th>Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productDetails &&
                      productDetails.map((itm, i) => {
                        return (
                          <tr key={i}>
                            <td>{itm.linesrNo}</td>
                            <td>{itm.itemId}</td>
                            <td>{itm.productName}</td>
                            <td>{itm.productSubTypeName}</td>
                            <td>{itm.productTypeName}</td>

                            <td>{itm.orderQuantity}</td>
                            <td>{itm.unitName}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Getpass-In Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-4">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["getpassDate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"in_time"}>{"InTime"}</label>
                      <input
                        type={"time"}
                        id={"in_time"}
                        required
                        onChange={(e) => {
                          setFields({ ...fields, inTime: e.target.value });
                        }}
                        ref={(el) => (frmRef.current["inTime"] = el)}
                        // value={fields.inTime}
                        className="form-control"
                      />
                    </div>
                
                   

                    <div className="col-md-4">
                      {" "}
                      <label> {`Gate Pass For`}</label>
                      <Select
                        value={selectedEntry}
                        required
                        ref={(el) => (frmRef.current["getpassType"] = el)}
                        onChange={(e) => {
                          setSelectedEntry(e);
                          setSelectedType("");
                          setFields({ ...fields, farmerType: e.value });
                        }}
                        options={farmerTypeOptions}
                      />{" "}
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      <label htmlFor={"type"}>{"Type"}</label>
                      <Select
                        value={selectedType}
                        required
                        ref={(el) => (frmRef.current["getpassFor"] = el)}
                        onChange={(e) => {
                          if (selectionType != null) {
                            console.log("selectionType", e.value);
                            setcropPlotList([]);
                            setSelectedType(e);
                            setFields({ ...fields, farmerType: e.value });
                          }
                        }}
                        options={selectionType}
                      ></Select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"farmer_id"}>
                        {switchEmplabelFar(selectedEntry)}
                      </label>

                      {switchEmpFar(selectedEntry) == "Existing Farmer" ? (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["farmerId"] = el)}
                          value={farmerId}
                          onChange={(e) => {
                            setFarmerId(e.target.value);
                            if (selectedType.value == "Procurement") {
                              getprocurementData(e.target.value);
                            } else {
                              getTobaccoprocurementData(e.target.value);
                            }
                            console.log("farmerId", e.target.value);
                          }}
                        >
                          <option value="">--Select Farmer--</option>
                          {farmerlist &&
                            farmerlist.map((x) => (
                              <option
                                key={x.farmerId}
                                employee-id={x.farmerId}
                                value={x.farmerId}
                                selected={
                                  props.update &&
                                  x.empId === props.update.supervisorEmployeeId
                                }
                              >
                                {x.farmerName + "(" + x.farmerNo + ")"}
                              </option>
                            ))}
                        </select>
                      ) : switchEmpFar(selectedEntry) == "Employee" ? (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["employeeId"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            setEmployeeId(e.target.value);
                            getemployeeloaddetail(e.target.value);
                          }}
                        >
                          <option value="">--Select Employee--</option>
                          {employeelist &&
                            employeelist.map((x) => (
                              <option
                                key={x.empId}
                                employee-id={x.empId}
                                value={x.empId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <span></span>
                      )}
                    </div>

                    {switchEmpFar(selectedEntry) == "Existing Farmer" &&
                    selectedType.value == "Procurement" ? (
                      <div className="col-md-4">
                        <label htmlFor={"docId"}>
                          {" "}
                          {switchEmplabelFar(selectedType)}{" "}
                        </label>
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["farmerId"] = el)}
                          value={docId}
                          onChange={(e) => {
                            var Id = "0";
                            if (e.target.value != "") {
                              Id = e.target.value;
                            }
                            loadProcurmentDetail(Id);
                            setDocId(Id);
                          }}
                        >
                          <option value="">--Select Procurement No--</option>
                          {cropPlotList &&
                            cropPlotList.map((x) => (
                              <option
                                key={x.procurementVehiclesDetailId}
                                employee-id={x.procurementVehiclesDetailId}
                                value={x.procurementVehiclesDetailId}
                              >
                                {x.procurementNo +
                                  " (" +
                                  x.vmeModelName +
                                  "-" +
                                  x.vehicleCode +
                                  ")"}
                              </option>
                            ))}
                        </select>
                      </div>
                    ) : switchEmpFar(selectedEntry) == "Existing Farmer" &&
                      selectedType.value == "Bring Tobacco Procurement" ? (
                      <div className="col-md-4">
                        <label htmlFor={"docId"}>
                          {" "}
                          {switchEmplabelFar(selectedType)}{" "}
                        </label>
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["farmerId"] = el)}
                          value={docId}
                          onChange={(e) => {
                            setDocId(e.target.value);
                            loadTobaccoProcurmentDetail(e.target.value);
                          }}
                        >
                          <option value="">
                            --Select Bring Tobacco Procurement No--
                          </option>
                          {curingDetail &&
                            curingDetail.map((x) => (
                              <option
                                key={x.curingId}
                                curing-id={x.curingId}
                                value={x.curingId}
                              >
                                {x.docNo}
                              </option>
                            ))}
                        </select>
                      </div>
                    ) : switchEmpFar(selectedEntry) == "Employee" &&
                      selectedType.value != "Direct Harvest" ? (
                      <div className="col-md-4">
                        <label htmlFor={"docId"}>
                          {" "}
                          {switchEmplabelFar(selectedType)}{" "}
                        </label>

                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["employeeId"] = el)}
                          value={docId}
                          onChange={(e) => {
                            var docid = 0;
                            if (e.target.value != "--Select Doc No--")
                              docid = e.target.value;

                            setDocId(docid);

                            var selectdocList = docList.filter(
                              (item) => item.docId == docid
                            );
                            if (selectdocList && selectdocList.length > 0) {
                              setdocNoFor(selectdocList[0].docNo);
                              setHarvestDate(selectdocList[0].harvestDate);
                            }

                            if (switchEmpFar(selectedType) == "Harvest") {
                              var docitem = selectdocList[0];
                              var productList = [];

                              //console.log("docitem", docitem);

                              setProductDetails((x) => [
                                ...x,
                                {
                                  srno: 1,
                                  cropId: docitem.cropId,
                                  cropName: docitem.cropName,
                                  varietyId: docitem.varietyId,
                                  varietyName: docitem.varietyName,
                                  itemQuantity: docitem.loadQuantity,
                                  unit: docitem.unitAbbreviation,
                                  unitId: docitem.loadQuantityUnitId,
                                  createdBy: parseInt(
                                    localStorage.getItem("id")
                                  ),
                                  orgId: localStorage.getItem("orgId"),
                                  status: 1,
                                  isSave: true,
                                },
                              ]);
                              frmRef.current.loadQuantity.value =
                                docitem.loadQuantity;
                              setLoadQuantityunitId(docitem.loadQuantityUnitId);
                              frmRef.current.vehicledrivername.value =
                                docitem.driverName;
                              frmRef.current.drivercontactnumber.value =
                                docitem.driverMobileNumber;
                              frmRef.current.vehiclenumber.value =
                                docitem.vehicleNumber;
                            } else {
                              setProductDetails([]);

                              getemployeeDocDetail(docid);
                            }
                          }}
                        >
                          <option value="">--Select Doc No--</option>
                          {docList &&
                            docList.map((x) => (
                              <option
                                key={x.docId}
                                doc-id={x.docId}
                                value={x.docId}
                                selected={
                                  props.update &&
                                  x.empId === props.update.supervisorEmployeeId
                                }
                              >
                                {x.docNo}
                              </option>
                            ))}
                        </select>
                      </div>
                    ) : (
                      <span></span>
                    )}
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      <label htmlFor={"person_name"}> {"Person Name"}</label>
                      <input
                        type={"text"}
                        id="person_name"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["personName"] = el)}
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"assignEmployeeId"}>
                        {"Assigned Supervisor"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        resource=""
                        required
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option selected value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      <label htmlFor={"work_contact"}>{"Contact Number"}</label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        pattern={integerPattern}
                        required
                        ref={(el) => (frmRef.current["contactnumber"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"whatsapp_contact"}>
                        {"Contact Number(whatsapp)"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_contact"}
                        pattern={integerPattern}
                        required
                        ref={(el) =>
                          (frmRef.current["whatAppContactNumber"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>{" "}
                      <br />
                      <button
                        className="btn btn-sm  btn-secondary mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          console.log("productDetails add", productDetails);

                          // switchEmplabelFar(selectedType)== "Existing Farmer"

                          switchEmpFar(selectedEntry) == "Existing Farmer" &&
                          selectedType.value == "Procurement"
                            ? setprocurmentClose(true)
                            : switchEmpFar(selectedEntry) ==
                                "Existing Farmer" &&
                              selectedType.value == "Bring Tobacco Procurement"
                            ? setprocurmentClose(true)
                            : switchEmpFar(selectedEntry) ==
                                "Existing Farmer" &&
                              selectedType.value == "Bring Produced"
                            ? setCropClose(true)
                            : switchEmpFar(selectedEntry) == "New Farmer"
                            ? setCropClose(true)
                            : switchEmpFar(selectedEntry) == "Employee" &&
                              selectedType.value == "Direct Harvest"
                            ? setCropClose(true)
                            : setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      {switchEmpFar(selectedType) == "Direct Harvest" ? (
                        <label htmlFor={"vehicle_number"}>
                          {"Vehicle Number"}
                        </label>
                      ) : (
                        <label htmlFor={"vehicle_number"}>
                          {"Vehicle Number"}
                        </label>
                      )}

                      {switchEmpFar(selectedType) == "Direct Harvest" ? (
                        <select
                          id="vmerId"
                          className="form-control"
                          ref={(el) => (frmRef.current["vmerId"] = el)}
                          value={vmerId}
                          onChange={(e) => {
                            setvmerId(e.target.value);
                            LoadVehicleData(e.target.value);
                          }}
                        >
                          <option>--Select Vehicle --</option>
                          {vehiclelist &&
                            vehiclelist.map((x) => (
                              <option
                                key={x.vmerId}
                                vmer-id={x.vmerId}
                                value={x.vmerId}
                              >
                                {x.vmeNo}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <input
                          type={"text"}
                          id={"vehicle_number"}
                          required
                          ref={(el) => (frmRef.current["vehiclenumber"] = el)}
                          className="form-control"
                        />
                      )}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"driver_name"}>
                        {" "}
                        {"Vehicle Driver Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"driver_name"}
                        required
                        ref={(el) => (frmRef.current["vehicledrivername"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"driver_contact_number"}>
                        {"Vehicle Driver Contact Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"driver_contact_number"}
                        pattern={integerPattern}
                        required
                        ref={(el) =>
                          (frmRef.current["drivercontactnumber"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"load_quantity"}>{"Load Quantity"}</label>
                      <input
                        type={"text"}
                        id={"load_quantity"}
                        required
                        pattern={decimalPattern}
                        ref={(el) => (frmRef.current["loadQuantity"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"unit"}>{"Unit"}</label>
                      <select
                        id="unitId"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["loadQuantityunitId"] = el)
                        }
                        value={loadQuantityunitId}
                        required
                        onChange={(e) => {
                          setLoadQuantityunitId(e.target.value);
                        }}
                      >
                        <option value="">--Select Unit--</option>
                        {unitList &&
                          unitList.map((x) => (
                            <option
                              key={x.unitId}
                              Unit-id={x.unitId}
                              value={x.unitId}
                            >
                              {x.unitAbbreviation}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remarkNote"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default GatePassInForm;
